import data from './data/heatmap.json';
import annotations from './data/data.json';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 15,
    right: 15,
    bottom: 0,
    left: 15,
  };

  const width = initialWidth - margins.right - margins.left;


  return {
    initialWidth,
    initialHeight: isMobile ? initialHeight * 2 : initialHeight,
    margins,
    width,
    data,
    annotations,
  };
}
